"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./FormGroup.scss");
var FormHeading_1 = __importDefault(require("../FormHeading"));
var FormGroup = function (_a) {
    var dusk = _a.dusk, _b = _a.flush, flush = _b === void 0 ? false : _b, children = _a.children, heading = _a.heading;
    return (react_1.default.createElement("fieldset", { "data-dusk": dusk, className: "form-group" + (flush ? ' form-group--flush' : '') },
        heading && react_1.default.createElement(FormHeading_1.default, { label: heading }),
        react_1.default.createElement("div", { className: "form-group--controls" }, children)));
};
exports.default = FormGroup;
//# sourceMappingURL=index.js.map